import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Pricing = () => {
  const [activeTab, setActiveTab] = useState('wedding');

  const weddingPackages = [
    {
      id: 1,
      name: 'Classic Moments Package',
      price: '$2,100',
      savings: 'Save $600',
      features: [
        '300 photos',
        '4-minute highlight video',
        '8 hours coverage',
        'Perfect for couples who want the most important moments beautifully captured'
      ],
      popular: false
    },
    {
      id: 2,
      name: 'Signature Wedding Experience',
      price: '$2,400',
      savings: 'Save $700',
      features: [
        '500 photos',
        '4-minute highlight video',
        '8 hours coverage',
        'Our most popular package—designed to fully capture your day'
      ],
      popular: true
    },
    {
      id: 3,
      name: 'Ultimate Love Story',
      price: '$3,500',
      savings: 'Save $1,100',
      features: [
        '300 photos',
        'Highlight video',
        '1-hour film',
        '8 hours coverage',
        'Relive your entire wedding day with a full cinematic experience'
      ],
      popular: false
    }
  ];

  const specialtyPackages = [
    {
      name: 'Elopement Experience',
      price: '$1,000',
      features: ['3–4 hours coverage', '150 photos', '2-minute highlight video']
    },
    {
      name: 'Cinematic Love Story',
      price: '$2,800',
      savings: 'Save $900',
      features: ['500 photos', '1-hour video', '8 hours coverage']
    },
    {
      name: 'Engagement + Wedding Bundle',
      price: '$3,000',
      features: ['Engagement session (30–50 photos)', '500 wedding photos', '4-minute highlight video']
    }
  ];

  const portraitSessions = [
    {
      name: 'Essential Portrait Session',
      price: '$120',
      features: ['30-minute session', '10 edited photos']
    },
    {
      name: 'Signature Portrait Session',
      price: '$250',
      features: ['1-hour session', '25 edited photos']
    },
    {
      name: 'Premium Portrait Experience',
      price: '$400',
      features: ['1.5–2 hour session', '50 edited photos', 'Multiple locations']
    },
    {
      name: 'The Platinum Experience',
      price: '$600',
      features: ['Unlimited timeframe', '100 edited photos', 'Multiple locations']
    }
  ];

  const eventPackages = [
    {
      name: 'Live Event Package',
      price: '$100',
      features: ['Photo coverage', '50 edited images']
    },
    {
      name: 'Performance Film Package',
      price: '$150',
      features: ['Video coverage', '3–5 minute highlight video']
    },
    {
      name: 'Full Show Experience',
      price: '$200',
      features: ['Photo + video coverage', '3–5 minute highlight', 'Full performance recording']
    }
  ];

  return (
    <div className="pt-20 md:pt-24 min-h-screen bg-light">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-forest via-secondary to-forest text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-64 h-64 bg-accent rounded-full blur-3xl animate-float"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-white rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="font-serif text-4xl md:text-6xl font-bold mb-4">
            Jesse Camarena Photo & Video
          </h1>
          <p className="text-xl text-gray-200 mb-2">
            Wedding Photo & Video Pricing Guide
          </p>
          <p className="text-sm text-gray-300">
            Limited availability — we only book a select number of weddings per month
          </p>
        </div>
      </section>

      {/* Tab Navigation */}
      <section className="py-8 bg-white border-b border-card/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => setActiveTab('wedding')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === 'wedding' ? 'bg-forest text-white shadow-lg' : 'bg-card text-forest hover:bg-forest hover:text-white'}`}
            >
              Wedding Packages
            </button>
            <button
              onClick={() => setActiveTab('specialty')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === 'specialty' ? 'bg-forest text-white shadow-lg' : 'bg-card text-forest hover:bg-forest hover:text-white'}`}
            >
              Specialty Packages
            </button>
            <button
              onClick={() => setActiveTab('portrait')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === 'portrait' ? 'bg-forest text-white shadow-lg' : 'bg-card text-forest hover:bg-forest hover:text-white'}`}
            >
              Portrait Sessions
            </button>
            <button
              onClick={() => setActiveTab('event')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === 'event' ? 'bg-forest text-white shadow-lg' : 'bg-card text-forest hover:bg-forest hover:text-white'}`}
            >
              Event Coverage
            </button>
          </div>
        </div>
      </section>

      {/* Wedding Packages */}
      {activeTab === 'wedding' && (
        <section className="py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest mb-4">
                Wedding Packages
              </h2>
              <p className="text-lg text-secondary">
                Complete coverage for your special day
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {weddingPackages.map((pkg) => (
                <div 
                  key={pkg.id}
                  className={`relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${pkg.popular ? 'border-4 border-forest' : 'border border-card/30'}`}
                >
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-forest text-white px-6 py-2 rounded-full text-sm font-semibold">
                        Most Popular
                      </span>
                    </div>
                  )}
                  <div className="text-center mb-6">
                    <h3 className="font-serif text-2xl font-bold text-forest mb-2">
                      {pkg.name}
                    </h3>
                    <div className="mb-2">
                      <span className="text-4xl font-bold text-forest">{pkg.price}</span>
                    </div>
                    <span className="text-accent font-semibold">{pkg.savings}</span>
                  </div>
                  <ul className="space-y-3 mb-6">
                    {pkg.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <svg className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span className="text-secondary text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link 
                    to="/contact"
                    className={`block w-full text-center font-semibold px-6 py-3 rounded-full transition-all duration-300 ${pkg.popular ? 'bg-forest text-white hover:shadow-xl' : 'bg-card text-forest hover:bg-forest hover:text-white'}`}
                  >
                    Book Now
                  </Link>
                </div>
              ))}
            </div>

            {/* À La Carte Pricing */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <h3 className="font-serif text-2xl font-bold text-forest mb-6">Photography (8 Hours)</h3>
                <ul className="space-y-3">
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">150 photos</span>
                    <span className="font-semibold text-forest">$1,200</span>
                  </li>
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">300 photos</span>
                    <span className="font-semibold text-forest">$1,400</span>
                  </li>
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">500 photos</span>
                    <span className="font-semibold text-forest">$1,800</span>
                  </li>
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">Additional photos (per 100)</span>
                    <span className="font-semibold text-forest">$150</span>
                  </li>
                  <li className="flex justify-between items-center">
                    <span className="text-secondary">Wedding past 8 hours</span>
                    <span className="font-semibold text-forest">+$200/hr</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <h3 className="font-serif text-2xl font-bold text-forest mb-6">Videography (8 Hours)</h3>
                <ul className="space-y-3">
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">4-minute highlight</span>
                    <span className="font-semibold text-forest">$1,300</span>
                  </li>
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">30-minute video</span>
                    <span className="font-semibold text-forest">$1,500</span>
                  </li>
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">1-hour video</span>
                    <span className="font-semibold text-forest">$1,900</span>
                  </li>
                  <li className="flex justify-between items-center pb-3 border-b border-card/30">
                    <span className="text-secondary">1hr+ video base</span>
                    <span className="font-semibold text-forest">$2,000 + $300–$500/hr</span>
                  </li>
                  <li className="flex justify-between items-center">
                    <span className="text-secondary">Wedding past 8 hours</span>
                    <span className="font-semibold text-forest">+$200/hr</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Specialty Packages */}
      {activeTab === 'specialty' && (
        <section className="py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest mb-4">
                Specialty Packages
              </h2>
              <p className="text-lg text-secondary">
                Tailored packages for unique celebrations
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {specialtyPackages.map((pkg, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-card/30">
                  <div className="text-center mb-6">
                    <h3 className="font-serif text-2xl font-bold text-forest mb-2">
                      {pkg.name}
                    </h3>
                    <div className="mb-2">
                      <span className="text-4xl font-bold text-forest">{pkg.price}</span>
                    </div>
                    {pkg.savings && <span className="text-accent font-semibold">{pkg.savings}</span>}
                  </div>
                  <ul className="space-y-3 mb-6">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <svg className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span className="text-secondary text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link 
                    to="/contact"
                    className="block w-full text-center font-semibold px-6 py-3 rounded-full bg-card text-forest hover:bg-forest hover:text-white transition-all duration-300"
                  >
                    Book Now
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Portrait Sessions */}
      {activeTab === 'portrait' && (
        <section className="py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest mb-4">
                Portrait Sessions
              </h2>
              <p className="text-lg text-secondary">
                Professional portrait photography
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
              {portraitSessions.map((session, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-card/30">
                  <div className="text-center mb-6">
                    <h3 className="font-serif text-2xl font-bold text-forest mb-2">
                      {session.name}
                    </h3>
                    <div className="mb-2">
                      <span className="text-4xl font-bold text-forest">{session.price}</span>
                    </div>
                  </div>
                  <ul className="space-y-3 mb-6">
                    {session.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <svg className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span className="text-secondary text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link 
                    to="/contact"
                    className="block w-full text-center font-semibold px-6 py-3 rounded-full bg-card text-forest hover:bg-forest hover:text-white transition-all duration-300"
                  >
                    Book Now
                  </Link>
                </div>
              ))}
            </div>

            {/* Portrait Add-Ons */}
            <div className="bg-white rounded-3xl p-8 shadow-lg max-w-2xl mx-auto">
              <h3 className="font-serif text-2xl font-bold text-forest mb-6 text-center">Portrait Add-Ons</h3>
              <ul className="space-y-3">
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">Extra photos (per photo)</span>
                  <span className="font-semibold text-forest">$10</span>
                </li>
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">Extra photos (15 photos)</span>
                  <span className="font-semibold text-forest">$60</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="text-secondary">Rush delivery (48 hrs)</span>
                  <span className="font-semibold text-forest">$50</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
      )}

      {/* Event Coverage */}
      {activeTab === 'event' && (
        <section className="py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest mb-4">
                Event & Band Coverage
              </h2>
              <p className="text-lg text-secondary">
                Professional coverage for live events and performances
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              {eventPackages.map((pkg, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-card/30">
                  <div className="text-center mb-6">
                    <h3 className="font-serif text-2xl font-bold text-forest mb-2">
                      {pkg.name}
                    </h3>
                    <div className="mb-2">
                      <span className="text-4xl font-bold text-forest">{pkg.price}</span>
                    </div>
                  </div>
                  <ul className="space-y-3 mb-6">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <svg className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span className="text-secondary text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link 
                    to="/contact"
                    className="block w-full text-center font-semibold px-6 py-3 rounded-full bg-card text-forest hover:bg-forest hover:text-white transition-all duration-300"
                  >
                    Book Now
                  </Link>
                </div>
              ))}
            </div>

            {/* Event Add-Ons */}
            <div className="bg-white rounded-3xl p-8 shadow-lg max-w-2xl mx-auto">
              <h3 className="font-serif text-2xl font-bold text-forest mb-6 text-center">Event Add-Ons</h3>
              <ul className="space-y-3">
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">Full set video</span>
                  <span className="font-semibold text-forest">$70</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="text-secondary">Social media clips (3)</span>
                  <span className="font-semibold text-forest">$70</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
      )}

      {/* Customization & Add-Ons */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest mb-4">
              Customization & Add-Ons
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-light rounded-3xl p-8 shadow-lg">
              <h3 className="font-serif text-2xl font-bold text-forest mb-6">Social Media Content</h3>
              <ul className="space-y-3">
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">1 reel</span>
                  <span className="font-semibold text-forest">$100</span>
                </li>
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">3 reels (Most Requested)</span>
                  <span className="font-semibold text-forest">$250</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="text-secondary">5 reels</span>
                  <span className="font-semibold text-forest">$400</span>
                </li>
              </ul>
            </div>

            <div className="bg-light rounded-3xl p-8 shadow-lg">
              <h3 className="font-serif text-2xl font-bold text-forest mb-6">Engagement Session</h3>
              <ul className="space-y-3">
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">Session</span>
                  <span className="font-semibold text-forest">$300</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="text-secondary">Add highlight video</span>
                  <span className="font-semibold text-forest">+$200</span>
                </li>
              </ul>
            </div>

            <div className="bg-light rounded-3xl p-8 shadow-lg">
              <h3 className="font-serif text-2xl font-bold text-forest mb-6">Video Add-Ons</h3>
              <ul className="space-y-3">
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">Extended highlight (6–8 min)</span>
                  <span className="font-semibold text-forest">+$200</span>
                </li>
                <li className="flex justify-between items-center pb-3 border-b border-card/30">
                  <span className="text-secondary">Full ceremony</span>
                  <span className="font-semibold text-forest">$300</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="text-secondary">Speeches/toasts</span>
                  <span className="font-semibold text-forest">$300</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Delivery Upgrades */}
          <div className="mt-8 bg-light rounded-3xl p-8 shadow-lg max-w-2xl mx-auto">
            <h3 className="font-serif text-2xl font-bold text-forest mb-6 text-center">Delivery Upgrades</h3>
            <ul className="space-y-3">
              <li className="flex justify-between items-center pb-3 border-b border-card/30">
                <span className="text-secondary">48–72 hour rush</span>
                <span className="font-semibold text-forest">$500</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="text-secondary">1-week delivery</span>
                <span className="font-semibold text-forest">$200</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-forest via-secondary to-forest text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6">
            Ready to Book?
          </h2>
          <p className="text-xl mb-8">
            Flexible payment plans available
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact"
              className="inline-block bg-white text-forest font-semibold px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              Contact Us
            </Link>
            <a 
              href="mailto:jessecamarena008@gmail.com"
              className="inline-block bg-accent text-forest font-semibold px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              Email Directly
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
